<template>
  <div :class="classes">
    <div ref="colorPickerBtn" class="d-flex">
      <slot>
        <div id="color-view" class="color-view" :style="getColorViewColor"></div>
        <div class="color-button" @click="openModal">
          <i class="aidicon aidicon-menu-down-outline"></i>
        </div>
      </slot>
    </div>
    <transition name="fade">
      <div v-show="modalVisible" ref="colorModal" :class="modalClass" :style="modalPosition">
        <div class="color-picker-mask" @click="closeModal"></div>
        <div class="color-area">
          <div ref="colorPancel" class="color-pancel" :style="getPancelColor">
            <div class="saturation-white">
              <div class="saturation-black"></div>
              <div ref="pickerBtn" class="picker-btn" :style="pickerBtnPosition"></div>
            </div>
          </div>
        </div>
        <div class="color-handle">
          <div class="color-change-container">
            <div class="color-preview">
              <div class="color-preview-border"></div>
              <div class="color-preview-bg" :style="getPreviewColor"></div>
            </div>
            <div class="color-handle-bar-container">
              <div ref="colorBar" class="color-bar">
                <div class="color-bar-btn"></div>
              </div>
              <div v-show="!noOpacity && currentMode === 'rgba'" ref="opacityBar" class="opacity-bar">
                <div class="opacity-bar-preview" :style="getOpacityBarColor"></div>
                <div class="opacity-bar-btn"></div>
              </div>
            </div>
          </div>
          <div class="d-flex">
            <div class="color-picker-input d-flex">
              <div v-if="currentMode === 'hex'" class="ml-6" :class="{'confirm': confirm}">
                <t-input v-model="hex" class="color-value" size="sm" @input-change="setValue()"></t-input>
                <!-- <span class="color-value">{{ hex }}</span> -->
                <span class="color-tips">hex</span>
              </div>
              <template v-if="currentMode === 'rgba'">
                <div v-for="i in 4" :key="i" class="ml-6">
                  <!-- @input-change="i === 4 ? rgba['rgba'[i - 1]] = aJuge(rgba['rgba'[i - 1]]) : rgba['rgba'[i - 1]] = rgbJuge(rgba['rgba'[i - 1]])" -->
                  <t-input v-model="rgba['rgba'[i - 1]]" class="color-value" size="sm" @keyup="checkRgbaValue(i)" @change="setValue()"></t-input>
                  <!-- <span class="color-value">{{ rgba['rgba'[i - 1]] }}</span> -->
                  <span class="color-tips">{{ 'rgba'[i - 1] }}</span>
                </div>
              </template>
            </div>
            <div v-if="mode === 'both'" class="color-type-btn" @click="switchCurrentMode">
              <svg viewBox="0 0 24 24">
                <path fill="#333" d="M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"></path>
                <path fill="#333" d="M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15Z"></path>
              </svg>
            </div>
          </div>
          <div v-if="confirm" class="mt-12 d-flex">
            <t-button class="w-50 mr-4" size="sm" @click="closeModal">取消</t-button>
            <t-button class="w-50 ml-4" color="primary" size="sm" @click="setValue(true)">确认</t-button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import * as constants from '../../utils/constants'
import utils from './util'
const prefixCls = `${constants.PREFIX_CLASS}color-picker`
export default {
  name: 'TColorPicker',
  mixins: [utils],
  props: {
    value: {
      type: String,
      default: 'rgb(255, 0, 0)'
    },
    visible: {
      type: Boolean,
      default: false
    },
    noOpacity: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'both',
      validator(value) {
        return [
          'both',
          'rgba',
          'hex'
        ].includes(value)
      }
    },
    placement: {
      validator(value) {
        let placementList = [
          'top-start',
          'top',
          'top-end',
          'bottom-start',
          'bottom',
          'bottom-end'
        ]
        return placementList.includes(value)
      },
      default: 'bottom-start'
    },
    confirm: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalVisible: this.visible,
      currentMode: 'rgba',
      initColor: 'rgb(255,0,0)',
      rgba: { r: 255, g: 0, b: 0, a: 1 },
      colorViewColor: { r: 255, g: 0, b: 0, a: 1 },
      hsb: { h: 0, s: 100, b: 100 },
      hex: '',
      pickerBtnLeft: '100%',
      pickerBtnTop: 0,
      pancelLeft: 0,
      pancelTop: 0
    }
  },
  computed: {
    classes() {
      return prefixCls
    },
    modalClass() {
      return `${prefixCls}-modal`
    },
    viewColor() {
      return {
        'background-color': this.value
      }
    },
    getColorViewColor() {
      let rgba = this.colorViewColor
      return {
        'background-color': `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`
      }
    },
    getPreviewColor() {
      let rgba = this.rgba
      return {
        'background-color': `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`
      }
    },
    getPancelColor() {
      let rgb = this.hsbToRgb({
        h: this.hsb.h,
        s: 100,
        b: 100
      })
      return {
        'background-color': `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`
      }
    },
    getOpacityBarColor() {
      let rgba = this.rgba
      return {
        'background': `linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(${rgba.r}, ${rgba.g}, ${rgba.b}) 100%)`
      }
    },
    pickerBtnPosition() {
      return {
        'left': `${this.pickerBtnLeft}`,
        'top': `${this.pickerBtnTop}`
      }
    },
    modalPosition() {
      // let placement = this.placement
      let position = {
        top: this.pancelTop + 'px',
        left: this.pancelLeft + 'px',
        right: 'auto',
        zIndex: 1051
      }
      // if (placement.indexOf('strat') > -1) {
      //   position.left = 0
      // }
      // if (placement.indexOf('end') > -1) {
      //   position.right = 0
      // }
      // if (placement.indexOf('top') > -1) {
      //   position.top = '-259px'
      // } else {
      //   position.top = '30px'
      // }
      // if (placement === 'top' || placement === 'bottom') {
      //   // 等同于弹窗 transform: translateX(-50%)
      //   // transform 会影响 mask 的 absolute 定位
      //   position.left = `-${225 / 2}px`
      // }
      return position
    }
  },
  watch: {
    value(val) {
      this.init()
    },
    visible(val) {
      this.modalVisible = val
    },
    modalVisible(val) {
      if (val) {
        this.$nextTick(() => {
          this.updatePositon()
          this.setColorBtnPostion()
          this.setOpacityBtnPostion()
        })
      }
    },
    currentMode() {
      if (this.mode === 'both') {
        this.setValue()
      }
    }
  },
  mounted() {
    document.body.appendChild(this.$refs.colorModal)
    if (this.mode !== 'both') {
      this.currentMode = this.mode
    }
    this.init()
    this.bindMove(this.$refs.colorPancel, this.setPosition, true)
    this.bindMove(this.$refs.colorBar, this.setColorBar, false)
    if (!this.noOpacity) {
      this.bindMove(this.$refs.opacityBar, this.setOpacityBar, false)
    }
  },
  beforeDestroy() {
    document.body.removeChild(this.$refs.colorModal)
  },
  methods: {
    // 初始化
    init() {
      let defaultValue = this.value
      if (defaultValue.indexOf('#') > -1) {
        if (this.noOpacity && defaultValue.length === 9) {
          defaultValue = defaultValue.slice(0, 7)
        }
        this.hex = defaultValue
        this.initColor = this.hexToRgb(defaultValue)
        this.rgba = this.initColor
        if (this.mode === 'both') {
          this.currentMode = 'hex'
        }
      } else if (defaultValue.indexOf('rgb') > -1) {
        let rgb = defaultValue.slice(4, -1).split(',')
        if (defaultValue.indexOf('rgba') > -1) {
          rgb = defaultValue.slice(5, -1).split(',')
          if (!this.noOpacity) {
            this.rgba.a = parseFloat(rgb[3])
          }
        }
        this.rgba.r = parseInt(rgb[0])
        this.rgba.g = parseInt(rgb[1])
        this.rgba.b = parseInt(rgb[2])
        this.initColor = this.rgba
        this.hex = `#${this.rgbToHex(this.rgba).toUpperCase()}`
      } else {
        if (defaultValue !== '') {
          throw Error('value 只能使用 RGBA 与 HEX 值')
        }
      }

      this.colorViewColor = Object.assign({}, this.initColor)

      if (this.modalVisible) {
        this.setColorBtnPostion()
        this.setOpacityBtnPostion()
      }
    },
    // 获取组件位置信息
    updatePositon() {
      const btn = this.$refs.colorPickerBtn
      let colorPickerBtnRect = btn.getBoundingClientRect()
      let top = colorPickerBtnRect.top + window.scrollY
      let left = colorPickerBtnRect.left + window.scrollX

      // 修改弹窗定位后需要进行位置计算
      let placement = this.placement
      if (placement === 'top' || placement === 'bottom') {
        left = left - (225 / 2 - (btn.offsetWidth / 2))
      }
      if (placement.indexOf('end') > -1) {
        left = left + btn.offsetWidth - 225
      }
      if (placement.indexOf('top') > -1) {
        this.pancelTop = top - 259
      } else {
        this.pancelTop = top + btn.offsetHeight + 8
      }
      this.pancelLeft = left
    },
    // 打开颜色选择器
    openModal() {
      this.updatePositon()
      this.modalVisible = true
    },
    // 关闭颜色选择器
    closeModal() {
      this.modalVisible = false
      this.$emit('update:visible', false)
    },
    // 切换颜色类型
    switchCurrentMode() {
      this.currentMode = this.currentMode === 'hex' ? 'rgba' : 'hex'
    },
    // 颜色区域移动
    setPosition(x, y) {
      let colorPancel = this.$refs.colorPancel
      let pancelWidth = colorPancel.offsetWidth
      let pancelHeight = colorPancel.offsetHeight
      let LEFT = parseInt(x - this.pancelLeft)
      let TOP = parseInt(y - this.pancelTop)
      let pointLeft = Math.max(0, Math.min(LEFT, pancelWidth))
      let pointTop = Math.max(0, Math.min(TOP, pancelHeight))

      this.pickerBtnLeft = pointLeft + 'px'
      this.pickerBtnTop = pointTop + 'px'

      this.hsb.s = parseInt(100 * pointLeft / pancelWidth)
      this.hsb.b = parseInt(100 * (pancelHeight - pointTop) / pancelHeight)

      this.updateRgb()
      this.setValue()
    },
    // 色相条移动
    setColorBar(elem, x) {
      let rect = elem.getBoundingClientRect()
      let elemWidth = elem.offsetWidth
      let X = Math.max(0, Math.min(x - rect.x, elemWidth))
      let colorBarBtn = this.$refs.colorModal.querySelector('.color-bar-btn')
      colorBarBtn.style.left = X + 'px'
      this.hsb.h = parseInt(360 * (elemWidth - X) / elemWidth)
      this.updateRgb()
      this.setValue()
    },
    // 设置默认色相条按钮位置
    setColorBtnPostion() {
      this.hsb = this.rgbToHsb(this.rgba)
      let elemWidth = this.$refs.colorBar.offsetWidth
      let X = elemWidth - (this.hsb.h / 360 * elemWidth)
      let colorBarBtn = this.$refs.colorModal.querySelector('.color-bar-btn')
      colorBarBtn.style.left = X + 'px'
    },
    // 透明度条移动
    setOpacityBar(elem, x) {
      let rect = elem.getBoundingClientRect()
      let elemWidth = elem.offsetWidth
      let moveLeft = Math.max(0, Math.min(x - rect.x, elemWidth))
      let opcityBarBtn = this.$refs.colorModal.querySelector('.opacity-bar-btn')

      opcityBarBtn.style.left = moveLeft + 'px'
      let opacity = moveLeft / elemWidth
      if (opacity !== 0 && opacity !== 1) {
        opacity = opacity.toFixed(2)
      }
      this.rgba.a = opacity
      this.setValue()
    },
    // 设置默认透明度条按钮位置
    setOpacityBtnPostion() {
      if (!this.noOpacity) {
        let moveLeft = this.rgba.a * this.$refs.colorBar.offsetWidth
        let opacityBarBtn = this.$refs.colorModal.querySelector('.opacity-bar-btn')
        opacityBarBtn.style.left = moveLeft + 'px'
      }
    },
    // 更新 rgb 值
    updateRgb () {
      var rgb = this.hsbToRgb(this.hsb)
      this.rgba.r = rgb.r
      this.rgba.g = rgb.g
      this.rgba.b = rgb.b
      this.hex = `#${this.rgbToHex(this.rgba)}`.toUpperCase()
    },
    // 更新 value 值
    setValue (emitFlag) {
      let rgba = this.rgba
      let val
      let rgbaStr = `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`
      if (this.currentMode === 'rgba') {
        val = rgbaStr
        this.hex = `#${this.rgbToHex(rgba)}`.toUpperCase()
      } else {
        val = this.hex
        this.rgba = this.hexToRgb(this.hex)
        rgba = this.rgba
        rgbaStr = `rgba(${rgba.r}, ${rgba.g}, ${rgba.b}, ${rgba.a})`
      }
      if (this.confirm && !emitFlag) {
        return false
      }
      this.colorViewColor = rgba
      this.$emit('input', val)
      this.$emit('change', {
        rgba: rgbaStr,
        rgb: `rgba(${rgba.r}, ${rgba.g}, ${rgba.b})`,
        hex: this.hex,
        hexNoOpacity: this.hex.length === 9 ? this.hex.slice(0, 7) : this.hex,
        opacity: rgba.a
      })

      if (this.confirm) {
        this.closeModal()
      }
    },

    rgbJuge(val) {
      val = val.replace(/[^\d-]/g, '')
      if ((val > 255 || val < 0)) {
        this.$Message.danger('要求 0 和 255 之间的整数。已插入最接近的数值。')
        if (val > 255) {
          return 255
        } else {
          return 0
        }
      } else {
        return val
      }
    },

    aJuge(val) {
      val = val.replace(/[^\d.]/g, '')
      if (val > 1 || val < 0) {
        this.$Message.danger('要求 0 和 1 之间。已插入最接近的数值。')
        if (val > 1) {
          return 1
        } else {
          return 0
        }
      } else {
        return val
      }
    },

    checkRgbaValue(idx) {
      if (idx === 4) {
        this.rgba['rgba'[idx - 1]] = this.aJuge(this.rgba['rgba'[idx - 1]])
      } else {
        this.rgba['rgba'[idx - 1]] = this.rgbJuge(this.rgba['rgba'[idx - 1]])
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/color-picker/color-picker.vue